<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总销售额" :total="'￥'+(price(sellerCount.total_order_price))">
          <a-tooltip title="用户实际支付,不含退款" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <trend  :flag="sellerCount.week_percent>=100?'up':'down'"  style="margin-right: 16px;">
              <span slot="term">周同比</span>
              {{sellerCount.week_percent}}%
            </trend>
            <trend  :flag="sellerCount.day_percent>=100?'up':'down'"  >
              <span slot="term">日同比</span>
              {{sellerCount.day_percent}}%
            </trend>
          </div>
          <template slot="footer">日均销售额<span>￥ {{price(sellerCount.day_av)}}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="访问量" :total="pvTotal | NumberFormat">
          <a-tooltip title="页面浏览次数PV" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area :data="pvChartData" yTitle="PV" />
          </div>
          <template slot="footer">日访问量<span> {{ pvToday | NumberFormat }}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="支付笔数" :total="NumberFormat(orderCount)">
          <a-tooltip title="实际支付的订单数,不含退款关闭的订单" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-bar  :data="payChartData" yTitle="订单数" />
          </div>
          <template slot="footer">转化率 <span>{{orderPercent}}%</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="客户数" :total="NumberFormat(customerCount)">
          <a-tooltip title="下过订单的客户数量" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area :data="customerChartData" yTitle="客户数" />
          </div>
          <template slot="footer">今日<span> {{  customerToday | NumberFormat }}</span></template>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <!--<div class="extra-wrapper" slot="tabBarExtraContent">-->
            <!--<div class="extra-item">-->
              <!--<a>今日</a>-->
              <!--<a>本周</a>-->
              <!--<a>本月</a>-->
              <!--<a>本年</a>-->
            <!--</div>-->
            <!--<a-range-picker :style="{width: '256px'}" />-->
          <!--</div>-->
          <a-tab-pane loading="true" tab="销售额" key="1">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="销售额排行" :data="orderPriceChartData" yTitle="销售额" />
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="用户排行" :list="userRankList"/>
              </a-col>
            </a-row>
          </a-tab-pane>
          <!--<a-tab-pane tab="访问量" key="2">-->
            <!--<a-row>-->
              <!--<a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">-->
                <!--<bar title="销售额趋势" />-->
              <!--</a-col>-->
              <!--<a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">-->
                <!--<rank-list title="门店销售排行榜" :list="rankList"/>-->
              <!--</a-col>-->
            <!--</a-row>-->
          <!--</a-tab-pane>-->
        </a-tabs>
      </div>
    </a-card>

    <a-row :gutter="12">
      <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card :loading="loading" :bordered="false" title="基地热门商品" :style="{ marginTop: '24px' }">
          <!--<a-dropdown :trigger="['click']" placement="bottomLeft" slot="extra">-->
            <!--<a class="ant-dropdown-link" href="#">-->
              <!--<a-icon type="ellipsis" />-->
            <!--</a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item>-->
                <!--<a href="javascript:;">操作一</a>-->
              <!--</a-menu-item>-->
              <!--<a-menu-item>-->
                <!--<a href="javascript:;">操作二</a>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
          <p v-for="(goods,i) in goodsRankList" :key="i">{{goods.name}} <em>销量:{{goods.total}}</em></p>
        </a-card>
      </a-col>
      <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card :loading="loading" :bordered="false" title="门店热门商品" :style="{ marginTop: '24px' }">
          <!--<a-dropdown :trigger="['click']" placement="bottomLeft" slot="extra">-->
            <!--<a class="ant-dropdown-link" href="#">-->
              <!--<a-icon type="ellipsis" />-->
            <!--</a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item>-->
                <!--<a href="javascript:;">操作一</a>-->
              <!--</a-menu-item>-->
              <!--<a-menu-item>-->
                <!--<a href="javascript:;">操作二</a>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
          <p v-for="(goods,i) in shopGoodsRankList" :key="i">{{goods.name}} <em>销量:{{goods.total}}</em></p>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import { analysisIndexData  } from '@/api/analysis'
  import ChartCard from '@/components/chart/ChartCard'
  import ACol from 'ant-design-vue/es/grid/Col'
  import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
  import MiniArea from '@/components/chart/MiniArea'
  import MiniBar from '@/components/chart/MiniBar'
  import MiniProgress from '@/components/chart/MiniProgress'
  import RankList from '@/components/chart/RankList'
  import Bar from '@/components/chart/Bar'
  import Trend from '@/components/Trend'


  export default {
    name: 'Analysis',
    components: {
      ATooltip,
      ACol,
      ChartCard,
      MiniArea,
      MiniBar,
      MiniProgress,
      RankList,
      Bar,
      Trend
    },
    data() {
      return {
        loading: true,
        sellerCount:{
          total_order_price:0,
          week_percent:0,
          day_percent:0,
          day_av:0,
        },
        pvTotal:0,
        pvToday:0,
        pvChartData:[
          {
            x:'2019-2-1',
            'PV': 0,
          },
          {
            x:'2019-2-2',
            'PV': 0,
          },
          {
            x:'2019-2-3',
            'PV': 0,
          },
          {
            x:'2019-2-4',
            'PV': 0,
          },
          {
            x:'2019-2-5',
            'PV': 0,
          },
          {
            x:'2019-2-6',
            'PV': 0,
          }
        ],
        payChartData:[
          {
            x:'2019-2-1',
            '订单数': 0,
          },
          {
            x:'2019-2-2',
            '订单数': 0,
          },
          {
            x:'2019-2-3',
            '订单数': 0,
          },
          {
            x:'2019-2-4',
            '订单数': 0,
          },
          {
            x:'2019-2-5',
            '订单数': 0,
          },
          {
            x:'2019-2-6',
            '订单数': 0,
          }
        ],
        orderCount:0,
        orderPercent:0,
        customerChartData:[
          {
            x:'2019-2-1',
            '客户数': 0,
          },
          {
            x:'2019-2-2',
            '客户数': 0,
          },
          {
            x:'2019-2-3',
            '客户数': 0,
          },
          {
            x:'2019-2-4',
            '客户数': 0,
          },
          {
            x:'2019-2-5',
            '客户数': 0,
          },
          {
            x:'2019-2-6',
            '客户数': 0,
          }
        ],
        customerCount:0,
        customerToday:0,
        userRankList:[
//            {
//              name:'张三',
//              total: '212元'
//            },
//            {
//              name:'张三',
//              total: '212元'
//            },
//            {
//              name:'张三',
//              total: '212元'
//            }
        ],
        orderPriceChartData:[
//          {
//            x:'2-1',
//            '销售额': 212,
//          },
//          {
//            x:'2-2',
//            '销售额': 212,
//          },
//          {
//            x:'2-3',
//            '销售额': 212,
//          },
//          {
//            x:'2-4',
//            '销售额': 212,
//          },
//          {
//            x:'2-5',
//            '销售额': 212,
//          },
//          {
//            x:'2-6',
//            '销售额': 212,
//          },
//          {
//            x:'2-7',
//            '销售额': 212,
//          },
//          {
//            x:'2-8',
//            '销售额': 212,
//          },
//          {
//            x:'2-9',
//            '销售额': 212,
//          },
//          {
//            x:'2-10',
//            '销售额': 212,
//          },
//          {
//            x:'2-11',
//            '销售额': 212,
//          },
//          {
//            x:'2-12',
//            '销售额': 212,
//          }
        ],
        goodsRankList:[
//          {
//            name:'商品1',
//            total: '212'
//          },
//          {
//            name:'商品2',
//            total: '212'
//          },
//          {
//            name:'商品3',
//            total: '212'
//          }
        ],
        shopGoodsRankList:[
//          {
//            name:'1商品1',
//            total: '212'
//          },
//          {
//            name:'1商品2',
//            total: '212'
//          },
//          {
//            name:'1商品3',
//            total: '212'
//          }
        ],
      }
    },
    created() {
      let that = this
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000);

      analysisIndexData( ).then(res => {
        that.sellerCount = res.data.sellerCount;
        that.pvTotal = res.data.pvTotal;
        that.pvToday = res.data.pvToday;
        that.pvChartData = res.data.pvChartData;
        that.payChartData = res.data.payChartData;
        that.orderCount = res.data.orderCount;
        that.customerCount = res.data.customerCount;
        that.customerToday = res.data.customerToday;
        that.userRankList = res.data.userRankList;
        that.orderPriceChartData = res.data.orderPriceChartData;
        that.goodsRankList = res.data.goodsRankList;
        that.shopGoodsRankList = res.data.shopGoodsRankList;
        that.customerChartData = res.data.customerChartData;

      })
    },
    methods:{
      NumberFormat(value){
        if (!value) {
          return '0'
        }
        const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
        return intPartFormat
      },
      price(data){
        if(data!=null){
            return (data/100).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,'$&,');
        }else{
             return 0;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
</style>